/*
 * @Description:
 * @Version: 2.0
 * @Autor: Lianzhidong
 * @Date: 2021-12-04 13:51:00
 * @LastEditors: Lianzhidong
 * @LastEditTime: 2022-03-15 20:24:33
 */
import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "@/layout";

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: "/",
    redirect: "/station/center",
  },
  {
    path: "/account",
    name: "account",
    component: () => import("@/views/account/index"),
    redirect: { name: "login" },
    hidden: true,
    children: [
      {
        path: "/login",
        name: "login",
        component: () => import("@/views/account/login"),
      },
      {
        path: "/register",
        name: "register",
        component: () => import("@/views/account/register"),
      },
    ],
  },
  {
    path: "/about",
    name: "about",
    component: () => import("@/views/About"),
  },
  // {
  //   path: "/",
  //   component: Layout,
  //   redirect: "/dashboard",
  //   meta: {
  //     title: "dashboard",
  //     icon: "nested",
  //   },
  //   children: [
  //     {
  //       path: "dashboard",
  //       name: "Dashboard",
  //       component: () => import("@/views/dashboard/index"),
  //       meta: { title: "Dashboard", icon: "dashboard" },
  //     },
  //   ],
  // },
  {
    path: "/screen",
    name: "screen",
    component: Layout,
    meta: {
      title: "大屏一览",
      icon: "icon-daping",
      breadcrumb: false, //  如果设置为false，则不会在breadcrumb面包屑中显示(默认 tru
    },
    children: [
      {
        path: "view",
        name: "screen-view",
        component: () => import("@/views/screen/index"),
        meta: {
          title: "大屏一览",
          icon: "daping",
        },
      },
    ],
  },
  {
    path: "/station",
    name: "station",
    component: Layout,
    meta: {
      title: "巡场中心",
      icon: "el-icon-alarm-clock",
      breadcrumb: false, //  如果设置为false，则不会在breadcrumb面包屑中显示(默认 tru
    },
    children: [
      {
        path: "center",
        name: "station-center",
        component: () => import("@/views/station/index"),
        meta: {
          title: "巡场中心",
          icon: "ditu",
        },
      },
    ],
  },
  {
    path: "/permission",
    name: "permission",
    component: Layout,
    meta: {
      title: "权限管理",
      icon: "nested",
      breadcrumb: false, //  如果设置为false，则不会在breadcrumb面包屑中显示(默认 tru
    },
    children: [
      {
        path: "userManage",
        name: "userManage",
        component: () => import("@/views/userManage/index"),
        meta: {
          title: "用户管理",
          icon: "yonghuguanli",
        },
      },
    ],
  },
  {
    path: "/alertEquip",
    name: "alertEquip",
    component: Layout,
    meta: {
      title: "设备告警",
      icon: "el-icon-alarm-clock",
      breadcrumb: false, //  如果设置为false，则不会在breadcrumb面包屑中显示(默认 tru
    },
    children: [
      {
        path: "alertEquip",
        name: "alertEquip",
        component: () => import("@/views/alertEquip/index"),
        meta: {
          title: "设备告警",
          icon: "icon-ml",
        },
      },
    ],
  },
  {
    path: "/operation",
    name: "operation",
    component: Layout,
    meta: {
      title: "运营商管理",
      icon: "el-icon-alarm-clock",
      breadcrumb: false, //  如果设置为false，则不会在breadcrumb面包屑中显示(默认 tru
    },
    children: [
      {
        path: "list",
        name: "operation-list",
        component: () => import("@/views/operation/index"),
        meta: {
          title: "运营商管理",
          icon: "yunying",
        },
      },
    ],
  },
  // {
  //   path: "/nested",
  //   component: Layout,
  //   redirect: "/nested/menu1",
  //   name: "Nested",
  //   meta: {
  //     title: "Nested",
  //     icon: "nested",
  //   },
  //   children: [
  //     {
  //       path: "menu1",
  //       component: () => import("@/views/nested/menu1/index"), // Parent router-view
  //       name: "Menu1",
  //       meta: { title: "Menu1" },
  //       children: [
  //         {
  //           path: "menu1-1",
  //           component: () => import("@/views/nested/menu1/menu1-1"),
  //           name: "Menu1-1",
  //           meta: { title: "Menu1-1" },
  //         },
  //         {
  //           path: "menu1-2",
  //           component: () => import("@/views/nested/menu1/menu1-2"),
  //           name: "Menu1-2",
  //           meta: { title: "Menu1-2" },
  //           children: [
  //             {
  //               path: "menu1-2-1",
  //               component: () =>
  //                 import("@/views/nested/menu1/menu1-2/menu1-2-1"),
  //               name: "Menu1-2-1",
  //               meta: { title: "Menu1-2-1" },
  //             },
  //             {
  //               path: "menu1-2-2",
  //               component: () =>
  //                 import("@/views/nested/menu1/menu1-2/menu1-2-2"),
  //               name: "Menu1-2-2",
  //               meta: { title: "Menu1-2-2" },
  //             },
  //           ],
  //         },
  //         {
  //           path: "menu1-3",
  //           component: () => import("@/views/nested/menu1/menu1-3"),
  //           name: "Menu1-3",
  //           meta: { title: "Menu1-3" },
  //         },
  //       ],
  //     },
  //     {
  //       path: "menu2",
  //       component: () => import("@/views/nested/menu2/index"),
  //       name: "Menu2",
  //       meta: { title: "menu2" },
  //     },
  //   ],
  // },
  {
    path: "/404",
    component: () => import("@/views/404"),
    hidden: true,
  },

  // 404 page must be placed at the end !!!
  { path: "*", redirect: "/404", hidden: true },
];

const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes,
  });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

export default router;
